import { render, staticRenderFns } from "./requisition-modal.vue?vue&type=template&id=347ffaee&"
import script from "./requisition-modal.vue?vue&type=script&lang=js&"
export * from "./requisition-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports